'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdEvStation = function MdEvStation(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.4 30l6.6-11.6h-3.4v-8.4l-6.6 12.5h3.4v7.5z m16.6-13.4c0.9 0 1.6-0.7 1.6-1.6s-0.7-1.6-1.6-1.6-1.6 0.7-1.6 1.6 0.7 1.6 1.6 1.6z m3-4.6c0.8 0.8 1.1 1.8 1.1 3v15.9c0 2.2-1.8 4.1-4.1 4.1s-4.1-1.9-4.1-4.1v-8.4h-2.5v12.5h-16.8v-26.6c0-1.8 1.6-3.4 3.4-3.4h10c1.8 0 3.4 1.6 3.4 3.4v11.6h1.6c1.8 0 3.4 1.6 3.4 3.4v7.5c0 0.9 0.7 1.6 1.6 1.6s1.6-0.7 1.6-1.6v-12.1c-0.5 0.3-1 0.3-1.6 0.3-2.3 0-4.1-1.8-4.1-4.1 0-1.8 1.1-3.3 2.6-3.9l-3.5-3.5 1.8-1.7z' })
        )
    );
};

exports.default = MdEvStation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/ev-station.js
// module id = 2276
// module chunks = 0